import { useEffect } from 'react';
import { ListProductDto } from '@checkfront/guest-experience-api-api-client-javascript-axios';
import { handleTrackingEvent } from '@guest-widgets/shared/src/utils/customerTracking/utils/trackingEventsHandler';
import { TrackingEventType } from '@guest-widgets/shared/src/utils/customerTracking/types';
import { usePrevious } from '@guest-widgets/shared/src/hooks/usePrevious';

export const useTrackingProductList = (products: ListProductDto[] = [], listId?: string) => {
  const previousListId = usePrevious(listId);

  useEffect(() => {
    if (products.length && listId) {
      handleTrackingEvent(TrackingEventType.VIEW_PRODUCT_LIST, { listId, products });
    }
  }, [products.length, listId]);
};
